import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useSuperAdminSingleSuscrip } from "../../../../context/SuperAdmin/SingleSuscriptContext";

const CreditsDetails = () => {
  const { plan, suscribedUsers, suscripcion } = useSuperAdminSingleSuscrip();

  const totalAsignados = suscribedUsers.length * plan.total_creditos;
  const totalSinAsignar =
    plan.total_creditos * plan.max_usuarios - totalAsignados;
  const totalGastados = suscripcion.creditos_gastados;

  return (
    <>
      {/* Detalles del plan */}
      <Paper sx={{ padding: 2, marginBottom: 2 }}>
        <Typography variant="h6" gutterBottom>
          Descripción del Plan
        </Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Detalle</TableCell>
                <TableCell>Valor</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>Límite créditos por usuario</TableCell>
                <TableCell>{plan.total_creditos}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Límite usuarios por plan</TableCell>
                <TableCell>{plan.max_usuarios}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>
                  Total general de créditos
                </TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>
                  {plan.total_creditos * plan.max_usuarios}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {/* Detalles de créditos */}
      <Paper sx={{ padding: 2 }}>
        <Typography variant="h6" gutterBottom>
          Detalle de Créditos
        </Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Detalle</TableCell>
                <TableCell>Valor</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>Total usuarios suscritos</TableCell>
                <TableCell>{suscribedUsers.length}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Total créditos asignados</TableCell>
                <TableCell>{totalAsignados}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Total créditos sin asignar</TableCell>
                <TableCell>{totalSinAsignar}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Total créditos gastados</TableCell>
                <TableCell>{totalGastados}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  );
};

export default CreditsDetails;
